var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C5.59663 0 0 5.59663 0 12.5C0 19.4034 5.59663 25 12.5 25C19.4034 25 25 19.4034 25 12.5C25 5.59663 19.4034 0 12.5 0ZM11.43 17.3339C11.2428 17.5211 10.9421 17.53 10.7443 17.3541L6.48245 13.5656C6.26975 13.3765 6.25754 13.0483 6.4556 12.8439L7.805 11.4515C7.98998 11.2607 8.29198 11.2479 8.49242 11.4225L10.7451 13.3843C10.9431 13.5568 11.2408 13.5467 11.4266 13.3612L17.5163 7.28456C17.7066 7.09469 18.0129 7.08925 18.2099 7.27225L19.5307 8.49982C19.7382 8.69269 19.7442 9.01928 19.5439 9.21961L11.43 17.3339Z",
    fill: "#39E476"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.306e07c1630a35e0160a9db65806fb02.svg";
export { ForwardRef as ReactComponent };